// Project imports
import MultipleTabsCheck from "./components/multipleTabsCheck";
import SoftwareVersionCheck from "./components/softwareVersionCheck";
import useSoMeAccounts from "./hooks/useSoMeAccounts";
import NetworkStatusCheck from "./components/networkStatusCheck";
import { isNative} from "lib/capacitor/capacitor";
import useRouteTracker from "./hooks/useRouteTracker";

const EnvironmentMonitor = () => {
  // Setup SoMe accounts
  useSoMeAccounts();
  useRouteTracker();

  return (
    <>
      {!isNative && <SoftwareVersionCheck />}
      <MultipleTabsCheck />
      <NetworkStatusCheck />
    </>
  );
};

export default EnvironmentMonitor;
